module.exports = __webpack_public_path__ + "assets/images/vcr_restaurant-04.0ecaf2b9a74d3406fd704f98ae83aa51.svg";